import { Link } from 'react-router-dom';

const CATEGORIES = [
  {
    to: '/movie',
    icon: 'ri-film-line',
    title: '电影频道',
    desc: '高分佳片与院线热映，一网打尽',
  },
  {
    to: '/tv',
    icon: 'ri-tv-2-line',
    title: '电视剧频道',
    desc: '热播连载与经典完结，随时追剧',
  },
  {
    to: '/news',
    icon: 'ri-newspaper-line',
    title: '影视资讯',
    desc: '行业动态与深度解读，先睹为快',
  },
];

export default function QuickCategories() {
  return (
    <section className="w-full px-4 md:px-8 -mt-10 md:-mt-14 relative z-30">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
        {CATEGORIES.map((cat) => (
          <Link
            key={cat.to}
            to={cat.to}
            className="group flex items-center gap-4 rounded-lg bg-background-50 border border-background-200 p-5 hover:border-accent-400 hover:bg-accent-50 transition-colors"
          >
            <span className="w-12 h-12 shrink-0 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-2xl group-hover:bg-accent-500 group-hover:text-foreground-950 transition-colors">
              <i className={cat.icon} />
            </span>
            <span className="min-w-0">
              <span className="block font-heading font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                {cat.title}
              </span>
              <span className="block mt-0.5 text-xs text-foreground-600 line-clamp-1">{cat.desc}</span>
            </span>
            <i className="ri-arrow-right-s-line ml-auto text-xl text-foreground-400 group-hover:text-accent-500 group-hover:translate-x-0.5 transition-all" />
          </Link>
        ))}
      </div>
    </section>
  );
}